var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjetivoSecondaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1982 32.463C30.1982 31.6291 30.8742 30.9531 31.7081 30.9531H64.926C65.7599 30.9531 66.436 31.6291 66.436 32.463V88.1172C66.436 89.3987 64.94 90.0976 63.9571 89.2752L48.929 76.7006C48.3592 76.2239 47.5273 76.2324 46.9675 76.7208L32.7007 89.1663C31.724 90.0184 30.1982 89.3247 30.1982 88.0285V32.463Z",
    fill: "#1C5029"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_532_16953)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 36.9925,
    r: 30.1981,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 36.9925,
    r: 30.5756,
    stroke: "url(#paint0_linear_532_16953)",
    strokeOpacity: 0.5,
    strokeWidth: 0.754952
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_532_16953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5997 25.6131C47.8257 24.9176 48.8097 24.9176 49.0357 25.6131L51.1991 32.2715C51.3002 32.5826 51.5901 32.7932 51.9171 32.7932H58.9182C59.6495 32.7932 59.9536 33.729 59.3619 34.1589L53.698 38.274C53.4334 38.4663 53.3226 38.807 53.4237 39.1181L55.5872 45.7765C55.8131 46.4721 55.0171 47.0505 54.4254 46.6206L48.7614 42.5055C48.4968 42.3132 48.1385 42.3132 47.8739 42.5055L42.2099 46.6206C41.6182 47.0505 40.8222 46.4721 41.0482 45.7765L43.2116 39.1181C43.3127 38.807 43.202 38.4663 42.9374 38.274L37.2734 34.1589C36.6817 33.729 36.9858 32.7932 37.7171 32.7932H44.7182C45.0453 32.7932 45.3351 32.5826 45.4362 32.2715L47.5997 25.6131Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_532_16953",
    x: 2.26521,
    y: -9.0595,
    width: 92.1043,
    height: 92.1043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.54952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_532_16953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_532_16953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_532_16953",
    x: 33.9411,
    y: 25.0913,
    width: 28.7535,
    height: 27.7164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.01981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5099
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_532_16953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_532_16953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_532_16953",
    x1: 18.1191,
    y1: 23.2661,
    x2: 71.5979,
    y2: 108.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjetivoSecondaryIcon);
export default __webpack_public_path__ + "static/media/objetivoSecondaryIcon.e1afe0a4ce3e50210815018aa0a8defc.svg";
export { ForwardRef as ReactComponent };